import React from "react";
import { Form } from "react-bootstrap";

/**
 * @param {{ label: any, className: any, htmlFor?: string }} props
 */
function FormFieldLabel({ label, className, htmlFor }) {
  return (
    <Form.Label className={className} htmlFor={htmlFor}>
      {label}
    </Form.Label>
  );
}

export default FormFieldLabel;
